<template>
  <div class='email-node-properties'>
    <div class='email-node-properties__header'>
      <div>
        <v-icon>alternate_email</v-icon>
      </div>
      <div class='email-node-properties__header__title'>
        <div class='email-node-properties__header__title__name'>
          {{name}}
        </div>
        <div class='email-node-properties__header__title__type'>
          {{$t(`ctc.properties.type.${data.type.toLowerCase()}`)}}
        </div>
      </div>
    </div>
    <v-expansion-panels multiple v-model="panels" flat>
      <!-- Leak Sources Panel -->
      <v-expansion-panel v-if="data.leakIndication">
        <v-expansion-panel-header class='panel-header'>{{$t('ctc.properties.leak_sources.title')}}</v-expansion-panel-header>
        <v-expansion-panel-content>
          <div class="leak-sources-content" v-if="data.leakSources && data.leakSources.length">
            <div class="leak-source-row" v-for="(source, index) in data.leakSources" :key="index">
              <div class="leak-source-label">{{source.leakName}}</div>
              <div class="leak-source-value">{{formatDate(source.breachDate)}}</div>
            </div>
          </div>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>
<script>
export default {
  name: 'EmailNodeProperties',
  props: {
    data: {
      type: Object,
      required: false,
      default: () => {},
    },
  },
  data() {
    return {
      panels: [0],
    };
  },
  computed: {
    name() {
      return this.data.name;
    },
  },
  methods: {
    formatDate(dateString) {
      if (!dateString) return '';
      const date = new Date(dateString);
      return date.toLocaleDateString();
    },
  },
};
</script>
<style scoped lang='scss'>
@import '~@/assets/styles/design-system';
.email-node-properties{
  display: flex;
  flex-direction: column;
  margin-top: rem(15);
  &__header{
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    margin-left: rem(10);
    &__title{
      display: flex;
      flex-direction: column;
      margin-left: rem(15);
      &__name{
        color: var(--text-primary);
        font-family: $font-family-regular;
        font-size: rem(16);
        font-weight: bold;
        letter-spacing: 0;
        line-height: rem(17);
        word-wrap: break-word;
        max-width: rem(240);
      };
      &__type{
        color: var(--text-tertiary);
        font-family: $font-family-regular;
        font-size: rem(10);
        letter-spacing: 1.1px;
        line-height: rem(15);
        margin-top: rem(5);
        text-transform: uppercase;
      };
    };
  }
  .panel-header {
    color: var(--text-primary);
    font-family: $font-family-medium;
    font-size: rem(14);
    letter-spacing: 0;
    line-height: rem(17);
    text-transform: uppercase;
  }
  .leak-sources-content {
    padding: rem(10);
  }
  .leak-source-row {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-bottom: rem(8);
  }
  .leak-source-label {
    min-width: rem(100);
    font-family: $font-family-regular;
    font-size: rem(10);
    letter-spacing: 1.1px;
    text-transform: uppercase;
    align-items: center;
  }
  .leak-source-value {
    color: var(--text-primary);
    font-family: $font-family-regular;
    font-size: rem(10);
    align-items: center;
  }
}
</style>
